












































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";

import { IStudent } from "@/models/interfaces/students";
import { IVuexState } from "@/models/interfaces/store";

import Checkbox from "@/components/BaseCheckbox/BaseCheckbox.vue";
import BasePopup from "@/components/BasePopup/BasePopup.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import LinearLoader from "@/components/LinearLoader/LinearLoader.vue";
import DataTable from "@/components/DataTable/DataTable.vue";

import EventBus from "@/utils/helpers/EventBus";
import SubjectsTable from "@/mixins/SubjectsTable.mixin";

import { Action } from "vuex-class";
import { AxiosError, AxiosResponse } from "axios";
import { eventCodeByName, EventsNames } from "@/analytics";
import amplitude from "amplitude-js";

@Component({
  components: {
    Checkbox,
    BasePopup,
    BaseButton,
    LinearLoader,
    DataTable
  }
})
export default class StudentsTable extends Mixins<SubjectsTable<IStudent>>(
  SubjectsTable
) {
  @Action("students/deleteStudents")
  private deleteStudents!: (
    studentsIds: string[]
  ) => Promise<AxiosResponse | AxiosError>;

  private isDeletionPending = false;

  private get tableColumns() {
    return [
      {
        value: "firstname",
        label: this.$t("tables.reports.firstName")
      },
      {
        value: "lastname",
        label: this.$t("tables.reports.lastName")
      },
      {
        value: "username",
        label: this.$t("tables.reports.username")
      },
      {
        value: "className",
        label: this.$t("tables.classes.group")
      }
    ];
  }

  private onDelete() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksDeleteStudentButton)} ${
          EventsNames.UserClicksDeleteStudentButton
        }`
      );
    if (!this.selectedDataItemsIds.length) {
      this.popupMessage = this.$t("components.errors.selectStudents") as string;
    } else {
      const studentsNames = this.selectedDataItemsIds
        .map(id => {
          const { firstname, lastname } = this.data.find(
            student => student.userId === id
          )!;

          return `${firstname} ${lastname}`;
        })
        .join(", ");

      this.popupMessage =
        (this.$t("components.errors.deleteStudents") as string) +
        ` ${studentsNames} `;
      this.action = "delete";
    }

    this.showPopup = true;
  }

  private onAdd() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksAddStudent)} ${
          EventsNames.UserClicksAddStudent
        }`
      );
    this.$router.push("/students/add");
  }

  private onImport() {
    this.$router.push("/students/import");
  }

  private onEdit() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksEditStudent)} ${
          EventsNames.UserClicksEditStudent
        }`
      );
    if (!this.selectedDataItemsIds.length) {
      this.popupMessage = this.$t("components.errors.selectStudents") as string;
      this.showPopup = true;
    } else if (this.selectedDataItemsIds.length > 1) {
      this.popupMessage = this.$t(
        "components.errors.editOneStudentAtOnce"
      ) as string;
      this.showPopup = true;
    } else {
      this.$router.push(`/students/${this.selectedDataItemsIds[0]}/edit`);
    }
  }

  private onPopupSubmit() {
    this.showPopup = false;

    switch (this.action) {
      case "delete":
        amplitude
          .getInstance()
          .logEvent(
            `${eventCodeByName(
              EventsNames.UserClicksOkOnPopupAfterStudentDelete
            )} ${EventsNames.UserClicksOkOnPopupAfterStudentDelete}`
          );
        this.deleteStudentsFromList();
        break;
      default:
        break;
    }
  }

  private deleteStudentsFromList() {
    this.isDeletionPending = true;
    this.deleteStudents(this.selectedDataItemsIds as string[])
      .then(r => {
        const error = r instanceof Error;
        if (error) {
          this.action = "";
          this.popupMessage = this.$t(
            "components.errors.failedToDeleteStudents"
          ) as string;
          this.showPopup = true;
        } else {
          this.selectedDataItemsIds = [];
        }
      })
      .finally(() => (this.isDeletionPending = false));
  }

  private mounted() {
    EventBus.$on("table-toolbar-delete", this.onDelete);
    EventBus.$on("table-toolbar-add", this.onAdd);
    EventBus.$on("table-toolbar-edit", this.onEdit);
    EventBus.$on("table-toolbar-import", this.onImport);

    this.selectedDataItemsIds = this.selectedItems;
  }

  private beforeDestroy() {
    EventBus.$off("table-toolbar-delete", this.onDelete);
    EventBus.$off("table-toolbar-add", this.onAdd);
    EventBus.$off("table-toolbar-edit", this.onEdit);
  }
}
